<template>
  <div class="motivate-add">
    <el-form
      :model="materialForm"
      label-width="120px"
      style="padding-right: 40px"
      :rules="materialRules"
      ref="materialFormRefs"
      size="small"
    >
      <el-form-item label="类型" prop="edMaterialTypeId">
        <el-select
          v-model="materialForm.edMaterialTypeId"
          placeholder="请选择类型"
          @change="addSelectType"
          clearable
          style="width: 100%"
          filterable
        >
          <el-option
            v-for="item in materialTypeOption"
            :key="item.id"
            :label="item.typeName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="对应师傅" prop="responsibleUserId">
        <el-select
          v-model="materialForm.responsibleUserId"
          placeholder="请选择对应师傅"
          style="width: 100%"
          filterable
        >
          <el-option
            :label="item.userName"
            v-for="item in userList"
            :key="item.id"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="型号" prop="edSettleMaterialModelId">
        <el-select
          v-model="materialForm.edSettleMaterialModelId"
          placeholder="请选择型号"
          @change="addSelectModel"
          clearable
          style="width: 100%"
          filterable
        >
          <el-option
            v-for="item in modelOptions"
            :key="item.id"
            :label="item.modelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单位" prop="unit">
        <el-input v-model="materialForm.unit" disabled></el-input>
      </el-form-item>
      <el-form-item label="单价" prop="unitPrice">
        <el-input
          v-model="materialForm.unitPrice"
          @input="calculateSubtotal"
        ></el-input>
      </el-form-item>
      <el-form-item label="数量" prop="quantity">
        <el-input
          v-model="materialForm.quantity"
          placeholder="请输入数量"
          @input="calculateSubtotal"
        ></el-input>
      </el-form-item>
      <el-form-item label="小计" prop="subtotal">
        <el-input v-model="materialForm.subtotal" disabled></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remarks">
        <el-input
          v-model="materialForm.remarks"
          type="textarea"
          maxlength="500"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
      <el-form-item label="订货时间" prop="orderTime">
        <el-date-picker
          style="width: 100%"
          v-model="materialForm.orderTime"
          placeholder="请选择订货时间"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="附件">
        <UpLoad
          :fileSize="100"
          ref="uploadRefs"
          @remove="removeFile"
          :limit="100"
          @uploadSuccess="handleUploadSuccess"
        ></UpLoad>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import UpLoad from "@/components/UpLoad";
import Big from "big.js";
export default {
  name: "Material",
  components: {
    UpLoad,
  },
  props: {
    dialogFlag: {
      type: Boolean,
      default: false,
    },
    responsibleUserId: {
      type: Number,
      default: null,
    },
    userList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      materialForm: {
        edMaterialTypeId: "",
        materialType: "",
        edSettleMaterialModelId: "",
        model: "",
        unit: "",
        unitPrice: "",
        quantity: "", // 数量
        subtotal: "",
        remarks: "",
        orderTime: "", // 订货时间
        attachment: "", // 附件地址
        attachmentIds: [], // 附件id
        responsibleUserId: null, // 对应师傅ID
      },
      materialRules: {
        edMaterialTypeId: [
          { required: true, message: "请选择类型", trigger: "change" },
        ],
        responsibleUserId: [
          { required: true, message: "请选择对应师傅", trigger: "change" },
        ],
        edSettleMaterialModelId: [
          { required: true, message: "请选择型号", trigger: "change" },
        ],
        unit: [{ required: true, message: "请输入单位", trigger: "blur" }],
        unitPrice: [{ required: true, message: "请输入单价", trigger: "blur" }],
        quantity: [{ required: true, message: "请输入数量", trigger: "blur" }],
        subtotal: [{ required: true, message: "请输入...", trigger: "blur" }],
      },
      modelOptions: [],
      modelOptionsBackup: [],
      materialTypeOption: [],
      fileList: [],
    };
  },
  watch: {
    dialogFlag: {
      handler(val) {
        if (val) {
          this.queryMaterialTypeOption();
          this.queryMaterialModelList();
          this.materialForm.attachmentIds = [];
          // 设置默认师傅ID（仅在表单中没有师傅ID时设置，避免覆盖复制时的师傅）
          if (this.responsibleUserId && !this.materialForm.responsibleUserId) {
            this.materialForm.responsibleUserId = this.responsibleUserId;
          }
        }
      },
      immediate: true,
    },
    responsibleUserId: {
      handler(val) {
        if (val && this.dialogFlag && !this.materialForm.responsibleUserId) {
          this.materialForm.responsibleUserId = val;
        }
      },
      immediate: true,
    },
    "materialForm.attachmentIds": {
      handler(val) {
        if (val.length > 0) {
          this.getFileList(val);
        }
      },
      deep: true,
    },
  },
  methods: {
    getFileList(val) {
      this.axios({
        url: "/attachment/list",
        method: "POST",
        data: {
          ids: val.join(","),
        },
      }).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          this.fileList = res.data.data.map((item) => {
            return {
              name: item.fileName,
              url: item.fileUrl,
              uid: item.id,
            };
          });
          this.$refs.uploadRefs.fileList = this.fileList;
        }
      });
    },
    removeFile(file, fileList) {
      this.materialForm.attachmentIds = fileList.map((item) => item.uid);
    },
    queryMaterialTypeOption() {
      //获取物料类型下拉
      this.axios({
        method: "get",
        url: "/v1/web/material-type/select-all-material-type",
      }).then((res) => {
        this.materialTypeOption = res.data.data;
      });
    },
    queryMaterialModelList() {
      //获取物料型号列表
      this.axios({
        method: "get",
        url: "/v1/web/settle-material-model/select-material-model",
        params: {
          size: 2000,
          page: 1,
        },
      }).then((res) => {
        this.modelOptionsBackup = res.data.data.list;
        if (this.materialForm.edMaterialTypeId) {
          this.modelOptions = this.modelOptionsBackup.filter(
            (item) => item.typeId == this.materialForm.edMaterialTypeId
          );
        }
      });
    },
    addSelectType(id) {
      //获取物料类型下拉选中值
      const data = this.materialTypeOption.find((item) => item.id == id);
      if (data) {
        this.materialForm.materialType = data.typeName;
        this.modelOptions = this.modelOptionsBackup.filter(
          (item) => item.typeId == id
        );
        this.clearModelSelected();
      }
    },
    addSelectModel(id) {
      const data = this.modelOptions.find((item) => item.id == id);
      if (data) {
        this.materialForm.model = data.modelName;
        this.materialForm.unit = data.unitDictIdStr;
        this.materialForm.unitPrice = data.price;
        // 当单价改变时，重新计算小计
        this.calculateSubtotal();
      }
    },
    clearModelSelected() {
      this.materialForm.edSettleMaterialModelId = "";
      this.materialForm.model = "";
      this.materialForm.unit = "";
      this.materialForm.unitPrice = "";
      this.materialForm.subtotal = "";
      this.materialForm.quantity = "";
    },
    calculateSubtotal() {
      if (this.materialForm.quantity == "") {
        this.materialForm.subtotal = 0;
      } else {
        const quantity = new Big(
          this.materialForm.quantity ? this.materialForm.quantity : 0
        );
        const unitPrice = new Big(
          this.materialForm.unitPrice ? this.materialForm.unitPrice : 0
        );
        this.materialForm.subtotal = quantity
          .times(unitPrice)
          .toFixed(2)
          .toString();
      }
    },
    handleUploadSuccess(res) {
      this.materialForm.attachmentIds.push(res);
    },
  },
};
</script>

<style scoped></style>
